<template>
    <div class="account">
        <el-breadcrumb separator-class="el-icon-arrow-right" v-if="postList.headerTitle">
            <el-breadcrumb-item>预算来源</el-breadcrumb-item>
        </el-breadcrumb>
        <el-row class="main_header">
            <div class="main_header_item" v-if="postList.effectiveness">
                <el-select style="width: 100%" v-model="effectiveness" placeholder="请选择有效性" size="mini" clearable>
                    <el-option v-for="item in effectivenessOptions" :key="item.value" :label="item.name" :value="item.value"> </el-option>
                </el-select>
            </div>
            <div class="main_header_item" v-if="postList.budget_item_rid">
                <el-select
                    style="width: 100%"
                    v-model="budget_item_rid"
                    filterable
                    remote
                    reserve-keyword
                    placeholder="请输入预算项目名称搜索"
                    :remote-method="remoteBudgetMethod"
                    :loading="budgetLoading"
                    size="mini"
                    clearable
                    value-key="rid"
                >
                    <el-option v-for="item in projectOptions" :key="item.rid" :label="item.name" :value="item.rid"> </el-option>
                </el-select>
            </div>
            <div class="main_header_item" v-if="postList.time_value">
                <el-date-picker
                    v-model="time_value"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd"
                    @change="timeChange"
                >
                </el-date-picker>
            </div>
        </el-row>
        <div class="main_list">
            <div class="flex">
                <el-button size="small" plain @click="addRow()" icon="el-icon-plus" v-if="postList.addBtn">新增预算源</el-button>
                <div class="main_header_btns">
                    <el-button type="primary" size="small" @click="getList(0, 1)" v-if="postList.searchBtn">搜索</el-button>
                    <el-button size="small" type="primary" plain @click="reset" v-if="postList.resetBtn">重置</el-button>
                    <el-button size="small" plain icon="el-icon-bottom" @click="getList(1)" :loading="down_loading" v-if="postList.downBtn"
                        >下载</el-button
                    >
                    <!-- 设置子组件 调整列显示隐藏 顺序 -->
                    <draggableList :draggable="draggable" @isErrShow="isErrshow" v-if="postList.setBtn"></draggableList>
                </div>
            </div>
            <el-table
                :data="tableData"
                border
                ref="tableDataRef"
                @sort-change="changeSort"
                :max-height="this.$tableHeight"
                @header-dragend="changeColWidth"
                class="budget_item_source"
                v-loading="loading"
                element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 255, 255, 0.8)"
                style="width: 100%"
            >
                <template v-for="(item, index) in colData">
                    <el-table-column
                        :key="index"
                        :prop="item.prop"
                        :label="item.title"
                        :min-width="item.width"
                        :sortable="item.sort"
                        align="left"
                        show-overflow-tooltip
                        v-if="colData[index].is_show"
                    >
                        <template slot-scope="scope" style="height: 100%">
                            <div v-if="item.prop == 'rid'">
                                <el-link type="primary" @click="handleClick(scope.row, item.prop)" style="font-size: 11px"
                                    >{{ scope.row[item.prop] }}
                                </el-link>
                            </div>
                            <div v-else-if="item.prop == 'budget_group_name'">
                                <el-link
                                    v-if="budget_group__show"
                                    type="primary"
                                    @click="handleClick(scope.row, item.prop)"
                                    style="font-size: 11px"
                                    >{{ scope.row[item.prop] }}
                                </el-link>
                                <span v-else> {{ scope.row[item.prop] }} </span>
                            </div>
                            <div v-else-if="item.prop == 'budget_item_name'">
                                <el-link v-if="link_show" type="primary" @click="handleClick(scope.row, item.prop)" style="font-size: 11px"
                                    >{{ scope.row[item.prop] }}
                                </el-link>
                                <span v-else> {{ scope.row[item.prop] }} </span>
                            </div>
                            <div v-else>
                                <span> {{ scope.row[item.prop] }} </span>
                            </div>
                        </template>
                    </el-table-column>
                </template>
                <el-table-column label="操作" align="center" fixed="right" width="80">
                    <template slot-scope="scope" style="height: 100%">
                        <el-tooltip class="item" effect="dark" content="编辑" placement="top-start">
                            <i class="el-icon-s-claim" @click="editRow(scope.row)"></i>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="删除" placement="top-start">
                            <i class="el-icon-delete-solid" @click="amenditem(scope.row.id)"></i>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total,prev, pager, next, sizes, jumper"
                    @current-change="currentChange"
                    @size-change="sizeChange"
                    :page-sizes="[10, 25, 50, 75, 100]"
                    :current-page.sync="page"
                    :page-size="row"
                    :total="total"
                ></el-pagination>
            </div>
            <el-dialog
                :before-close="beforeClose"
                :close-on-click-modal="false"
                v-dialogDrag
                :title="title"
                :visible.sync="dialogVisible"
                width="550px"
            >
                <el-form :model="ruleForm" :rules="rules" ref="ruleDetailsForm" :label-position="labelPosition">
                    <el-form-item label="预算项目：" prop="budget_item_name" label-width="120px">
                        <el-select
                            style="width: 320px"
                            v-model="ruleForm.budget_item_name"
                            filterable
                            remote
                            reserve-keyword
                            placeholder="请输入预算项目名称搜索"
                            :remote-method="remoteBudgetMethodItem"
                            :loading="budgetLoadingItem"
                            size="mini"
                            clearable
                            value-key="rid"
                            @change="budgetChange"
                        >
                            <el-option v-for="item in projectOptionsItem" :key="item.rid" :label="item.name" :value="item"> </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="金额：" prop="amount" label-width="120px">
                        <el-input
                            style="width: 320px"
                            v-model="ruleForm.amount"
                            placeholder="请输入金额"
                            @keyup.native="ruleForm.amount = oninput(ruleForm.amount)"
                            clearable
                            size="mini"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="审批状态：" label-width="120px" prop="approval_status" v-if="isDefault == 1">
                        <el-select
                            style="width: 320px"
                            v-model="ruleForm.approval_status"
                            placeholder="请选择审批状态"
                            size="mini"
                            clearable
                        >
                            <el-option v-for="item in statusOptions" :key="item.id" :label="item.value" :value="item.id"> </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="分配期间：" prop="period" label-width="120px" v-if="typeShow">
                        <el-select
                            filterable
                            v-model="ruleForm.period"
                            placeholder="请选择分配期间"
                            clearable
                            style="width: 320px"
                            size="mini"
                        >
                            <el-option v-for="item in periodOption" :key="item.value" :label="item.name" :value="item.value"> </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="生效日期：" prop="effective_date" label-width="120px" v-if="typeShow">
                        <el-date-picker
                            style="width: 320px"
                            size="mini"
                            :picker-options="pickerOptions"
                            v-model="ruleForm.effective_date"
                            type="date"
                            placeholder="请选择生效日期"
                            value-format="yyyy-MM-dd"
                            clearable
                        >
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="备注：" prop="remark" label-width="120px">
                        <el-input placeholder="请输入备注" style="width: 320px" v-model="ruleForm.remark" size="mini"></el-input>
                    </el-form-item>
                    <el-form-item label="提交人职位：" label-width="120px" prop="submission_hierarchy_rid" v-if="isDefault == 1">
                        <el-select
                            size="mini"
                            v-model="ruleForm.submission_hierarchy_rid"
                            placeholder="请选择提交人职位"
                            clearable
                            style="width: 320px"
                            filterable
                        >
                            <el-option v-for="item in hierarchyOptions" :key="item.value" :label="item.name" :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="dialogVisible = false">取 消</el-button>
                    <el-button type="primary" @click="okData('ruleDetailsForm')">确 定</el-button>
                </span>
            </el-dialog>
        </div>
    </div>
</template>
<script>
import { onReSize } from '../../../../js/common';
import draggableList from '../../../common/Drawer.vue';
export default {
    inject: ['reload'],
    //注册draggable组件
    components: {
        draggableList
    },
    name: 'budgetSourceComponent',
    data() {
        return {
            pickerOptions: {
                disabledDate(time) {
                    var datetime = new Date();
                    return time.getTime() < Date.now() - 3600 * 1000 * 24 || time.getTime() > new Date(datetime.getFullYear() + 1, 0, 0); // 选当前版本时间之前的版本时间
                }
            },
            draggable: {
                data_name: 'budget_item_source'
            },
            tableData: [],
            typeShow: false,
            down_loading: false,
            colData: [],
            total: 0,
            page: 1,
            row: 25,
            sort: '', //排序参数
            data_name: '', //排序参数
            loading: true,
            budget_item_rid: '',
            effectiveness: '',
            time_value: '',
            effectivenessOptions: [], // 有效性下拉
            budgetOptions: [], // 预算项目下拉搜索
            budgetLoading: false,
            projectOptions: [],
            start_time: '',
            end_time: '',
            title: '',
            dialogVisible: false,
            ruleForm: {
                budget_item_rid: '',
                budget_item_name: '',
                period: '',
                effective_date: '',
                amount: '',
                remark: '',
                budget_item_source_group_rid: '',
                approval_status: 2,
                rid: '',
                submission_hierarchy_rid: ''
            },
            rules: {
                budget_item_name: [{ required: true, message: '请输入预算项目', trigger: 'blur' }],
                amount: [{ required: true, message: '请输入金额', trigger: 'blur' }],
                approval_status: [{ required: true, message: '请选择审批状态', trigger: 'blur' }],
                submission_hierarchy_rid: [{ required: true, message: '请选择提交人职位', trigger: 'blur' }]
            },
            labelPosition: 'right',
            budgetLoadingItem: false,
            projectOptionsItem: [],
            statusOptions: [
                {
                    value: '草稿',
                    id: 1
                },
                {
                    value: '审批中',
                    id: 2
                }
            ],
            periodOption: [],
            hierarchyOptions: [],
            can_operator: '',
            approval_status: '',
            isDefault: '',
            budget_item_source_group_rid: '',
            postList1: {},
            link_show: true,
            budget_group__show: true,
            completion_date: ''
        };
    },
    props: {
        postList: {
            type: Object
        }
    },
    created() {
        if (this.postList.params) {
            this.row = 10;
        }
        this.postList1 = this.postList;
        this.completion_date = this.postList.params.time;
    },
    watch: {
        postList1: {
            handler(newValue, oldValue) {
                if (newValue.params) {
                    if (newValue.params.budget_item_source_group_rid) {
                        this.budget_item_source_group_rid = newValue.params.budget_item_source_group_rid;
                        this.budget_group__show = false;
                    } else {
                        this.budget_group__show = true;
                    }
                    if (newValue.params.budget_item_rid) {
                        this.budget_item_rid = newValue.params.budget_item_rid;
                        this.link_show = false;
                    } else {
                        this.link_show = true;
                    }
                    this.can_operator = this.postList.params.can_operator;
                    this.isDefault = this.postList.params.isDefault;
                    this.approval_status = this.postList.params.approval_status;
                }
                this.getList(0); //获取列表
            },
            deep: true
        }
    },
    beforeMount() {
        //详情内调用不用本地存储的params
        if (!this.postList.params) {
            //列表页面调用 优先取本地存储
            var paramsList = JSON.parse(localStorage.getItem('paramsList'));
            if (paramsList['budgetSource_params']) {
                this.page = paramsList['budgetSource_params'].page;
                this.row = paramsList['budgetSource_params'].row;
                this.budget_item_rid = paramsList['budgetSource_params'].budget_item_rid;
                // this.data_name = paramsList['budgetSource_params'].data_name;
                // this.sort = paramsList['budgetSource_params'].sort;
                this.start_time = paramsList['budgetSource_params'].start_time;
                this.end_time = paramsList['budgetSource_params'].end_time;
                this.effectiveness = paramsList['budgetSource_params'].effectiveness;
                this.time_value = paramsList['budgetSource_params'].time_value;
            }
        }
    },
    mounted() {
        this.getEffectiveness();
        this.getDropdownPeriod();
        // this.getHierarchies();
        this.$nextTick(() => {
            this.selectedColData(); //筛选列
            if (this.postList.params) {
                //如果详情列表需要搜索参数 重置按钮放出来 注意 传来的id不可被重置掉
                this.row = 10;
            } else {
                this.getList(0); //获取列表
            }
        });
    },
    methods: {
        //数据确认
        okData(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if (this.type == 1) {
                        this.submitAddData(); // 新增
                    } else if (this.type == 2) {
                        this.submitEditData(); //修改
                    }
                } else {
                    return false;
                }
            });
        },
        //新增
        submitAddData() {
            let params = {
                budget_item_rid: this.ruleForm.budget_item_rid,
                period: this.ruleForm.period ? this.ruleForm.period : '',
                effective_date: this.ruleForm.effective_date ? this.ruleForm.effective_date : '',
                amount: this.ruleForm.amount,
                remark: this.ruleForm.remark ? this.ruleForm.remark : '',
                budget_item_source_group_rid: this.budget_item_source_group_rid,
                approval_status: this.ruleForm.approval_status ? this.ruleForm.approval_status : '1',
                submission_hierarchy_rid: this.ruleForm.submission_hierarchy_rid ? this.ruleForm.submission_hierarchy_rid : ''
            };
            this.$api
                .budgetItemSourceInsert(params)
                .then((res) => {
                    if (res.code == 0) {
                        this.dialogVisible = false;
                        this.$message({
                            message: '新增成功！',
                            type: 'success'
                        });
                        this.getList(0); //获取详情
                    }
                })
                .catch((error) => {});
        },
        //编辑
        submitEditData() {
            let params = {
                rid: this.ruleForm.rid,
                budget_item_rid: this.ruleForm.budget_item_rid,
                period: this.ruleForm.period ? this.ruleForm.period : '',
                effective_date: this.ruleForm.effective_date ? this.ruleForm.effective_date : '',
                amount: this.ruleForm.amount,
                remark: this.ruleForm.remark ? this.ruleForm.remark : '',
                approval_status: this.ruleForm.approval_status ? this.ruleForm.approval_status : '1',
                submission_hierarchy_rid: this.ruleForm.submission_hierarchy_rid ? this.ruleForm.submission_hierarchy_rid : ''
            };
            this.$api
                .budgetItemSourceUpdate(params)
                .then((res) => {
                    if (res.code == 0) {
                        this.dialogVisible = false;
                        this.$message({
                            message: '修改成功！',
                            type: 'success'
                        });
                        this.getList(0); //获取详情
                    }
                })
                .catch((error) => {});
        },
        //获取提交人职位
        // getHierarchies() {
        //     let params = {};
        //     this.$api
        //         .adminHierarchies(params)
        //         .then((res) => {
        //             if (res.code == 0) {
        //                 this.hierarchyOptions = res.data;
        //                 if (res.data.length != 0) {
        //                     this.ruleForm.submission_hierarchy_rid = res.data[0].value;
        //                 }
        //             }
        //         })
        //         .catch((error) => {});
        // },
        //分配期间下拉
        getDropdownPeriod() {
            let params = {};
            this.$api
                .dropdownPeriod(params)
                .then((res) => {
                    if (res.code == 0) {
                        this.periodOption = res.data;
                    }
                })
                .catch((error) => {});
        },
        //正则验证
        oninput(value) {
            //可以输入正负号，小数点，保留两位
            let str = value;
            if (isNaN(str) && !/^-$/.test(str)) {
                str = '';
            }
            if (!/^[+-]?\d*\.{0,1}\d{0,1}$/.test(str)) {
                str = str.replace(/\.\d{2,}$/, str.substr(str.indexOf('.'), 3));
            }
            return str;
        },
        //预算项目下拉框改变
        budgetChange(val) {
            this.ruleForm.budget_item_rid = val.rid;
            if (val.status == 1) {
                this.typeShow = true;
            } else {
                this.ypeShow = false;
            }
        },
        remoteBudgetMethodItem(query) {
            if (query !== '') {
                this.budgetLoadingItem = true;
                let params = {
                    key: query,
                    completion_date: this.completion_date
                };
                this.$api
                    .searchBudgetItems(params)
                    .then((res) => {
                        if (res.code == 0) {
                            setTimeout(() => {
                                this.budgetLoadingItem = false;
                                this.projectOptionsItem = res.data;
                            }, 200);
                        } else {
                            this.projectOptionsItem = [];
                        }
                    })
                    .catch((error) => {});
            } else {
                this.budgetLoadingItem = false;
                this.projectOptionsItem = [];
            }
        },
        //弹窗关闭前的优化
        beforeClose() {
            this.dialogVisible = false;
            this.$refs['ruleDetailsForm'].resetFields();
        },
        //版本时间框改变赋值
        timeChange(val) {
            if (val) {
                this.start_time = val[0];
                this.end_time = val[1];
            } else {
                this.start_time = '';
                this.end_time = '';
            }
        },
        //有效性下拉
        getEffectiveness() {
            var params = {};
            this.$api
                .dropdownEffectiveness(params)
                .then((res) => {
                    if (res.code == 0) {
                        this.effectivenessOptions = res.data;
                    }
                })
                .catch((error) => {});
        },
        //项目下拉
        remoteBudgetMethod(query) {
            if (query !== '') {
                this.budgetLoading = true;
                let params = {
                    key: query,
                    completion_date: this.completion_date
                };
                this.$api
                    .searchBudgetItems(params)
                    .then((res) => {
                        if (res.code == 0) {
                            setTimeout(() => {
                                this.budgetLoading = false;
                                this.projectOptions = res.data;
                            }, 200);
                        } else {
                            this.projectOptions = [];
                        }
                    })
                    .catch((error) => {});
            } else {
                this.budgetLoading = false;
                this.projectOptions = [];
            }
        },
        addRow() {
            if (this.can_operator == 2) {
                this.$message({
                    message: '系统预算源组不允许操作',
                    type: 'warning'
                });
            } else {
                this.title = '新增预算源';
                this.ruleForm = {
                    budget_item_rid: '',
                    budget_item_name: '',
                    period: '',
                    effective_date: '',
                    amount: '',
                    remark: '',
                    budget_item_source_group_rid: '',
                    approval_status: 2,
                    rid: '',
                    submission_hierarchy_rid:
                        this.hierarchyOptions[0] && this.hierarchyOptions[0].value ? this.hierarchyOptions[0].value : ''
                };
                this.type = 1;
                this.dialogVisible = true;
            }
        },
        //新增 编辑预算源
        editRow(row) {
            if (row.can_operator == 2) {
                this.$message({
                    message: '系统预算源组不允许操作',
                    type: 'warning'
                });
            } else {
                this.title = '修改预算源';
                this.ruleForm = {
                    budget_item_rid: row.budget_item_rid,
                    budget_item_name: row.budget_item_name,
                    period: row.period,
                    effective_date: row.effective_date,
                    amount: row.amount,
                    remark: row.remark,
                    approval_status: row.approval_status,
                    rid: row.rid,
                    submission_hierarchy_rid: row.submission_hierarchy_rid
                };
                this.type = 2;
                this.dialogVisible = true;
            }
        },
        //子组件更新完毕
        isErrshow(data) {
            //刷新下页面
            this.reload();
        },
        //列宽改变事件
        changeColWidth(nw, ow, col, evt) {
            onReSize('budget_item_source', this);
        },
        //筛选列
        selectedColData() {
            this.colData = JSON.parse(localStorage.getItem('dataList')).budget_item_source;
        },
        // 从后台获取数据,重新排序
        changeSort(val) {
            this.data_name = val.prop;
            if (val.order == 'ascending') {
                this.sort = 'asc';
            } else if (val.order == 'descending') {
                this.sort = 'desc';
            }
            if (!this.postList.params) {
                var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                if (newParamsList['budgetSource_params']) {
                    newParamsList['budgetSource_params'].data_name = val.prop;
                    newParamsList['budgetSource_params'].sort = this.sort;
                    localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                }
            }
            if (this.sort !== '') {
                this.getList(0); //获取列表
            }
        },
        //跳转详情
        handleClick(row, prop) {
            if (prop == 'rid') {
                this.$router.push({
                    path: '/budgetItemSourceDetail',
                    query: {
                        id: row.rid
                    }
                });
            } else if (prop == 'budget_group_name') {
                this.$router.push({
                    path: '/budgetSourceDetail',
                    query: {
                        id: row.budget_item_source_group_rid
                    }
                });
            } else if (prop == 'budget_item_name') {
                this.$router.push({
                    path: '/budgetItemDetails',
                    query: {
                        id: row.budget_item_rid
                    }
                });
            }
        },
        //删除当前行 预算源
        amenditem(id) {
            var params = {
                id: id
            };
            let messages = '此操作将删除此条数据，是否继续?';
            this.$msgbox({
                title: '消息',
                message: messages,
                showCancelButton: true,
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                closeOnPressEscape: false,
                closeOnClickModal: false,
                beforeClose: (action, instance, done) => {
                    if (action === 'confirm') {
                        instance.confirmButtonLoading = true;
                        instance.confirmButtonText = '删除...';
                        this.$api
                            .budgetItemSourceDelete(params)
                            .then((res) => {
                                done();
                                setTimeout(() => {
                                    instance.confirmButtonLoading = false;
                                }, 300);
                                if (res.code == 0) {
                                    this.$message({
                                        showClose: true,
                                        message: '删除成功',
                                        type: 'success'
                                    });
                                    this.$bus.$emit('fullPath', this.$route.fullPath);
                                    this.getList(0);
                                }
                            })
                            .catch((error) => {
                                done();
                                setTimeout(() => {
                                    instance.confirmButtonLoading = false;
                                }, 300);
                            });
                    } else {
                        done();
                    }
                }
            })
                .then((action) => action)
                .catch((error) => error);
        },
        //获取列表数据
        getList(type_data, type) {
            if (type == 1) {
                this.page = 1;
            }
            var params = {
                page: this.page,
                row: this.row,
                budget_item_rid: this.budget_item_rid,
                budget_item_source_group_rid: this.budget_item_source_group_rid,
                start_time: this.start_time,
                end_time: this.end_time,
                is_export: type_data,
                effectiveness: this.effectiveness
            };
            //当点击 或者触发回车事件保存参数
            if (type == 1) {
                var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                newParamsList['budgetSource_params'] = params;
                localStorage.setItem('paramsList', JSON.stringify(newParamsList));
            }
            if (type_data == 0) {
                this.loading = true;
                this.$api
                    .budgetItemSourceLists(params)
                    .then((res) => {
                        this.loading = false;
                        if (res.code == 0) {
                            this.tableData = res.data.data;
                            this.total = res.data.total;
                            //判断当前搜素页面参数是否大于最后一页 大于的话取最后一页的参数存起来并用最后一页的参数请求
                            if (res.data.current_page > res.data.last_page) {
                                var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                                newParamsList['budgetSource_params'].page = res.data.last_page;
                                localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                                this.page = res.data.last_page;
                            }
                        }
                    })
                    .catch((error) => {
                        this.loading = false;
                    });
            } else {
                this.down_loading = true;
                params.page = 1;
                this.$api
                    .budgetItemSourceListsDownFile(params)
                    .then((res) => {
                        this.$message({
                            message: '下载成功!',
                            type: 'success'
                        });
                        this.down_loading = false;
                    })
                    .catch((error) => {
                        this.down_loading = false;
                    });
            }
        },
        //重置页面数据
        reset() {
            this.budget_item_rid = '';
            this.start_time = '';
            this.end_time = '';
            this.effectiveness = '';
            this.time_value = '';
            var params = {
                page: 1,
                row: 25,
                sort: ['', ''],
                budget_item_rid: '',
                start_time: '',
                end_time: '',
                effectiveness: '',
                time_value: ''
            };
            var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
            newParamsList['budgetSource_params'] = params;
            localStorage.setItem('paramsList', JSON.stringify(newParamsList));
            this.getList(0);
        },
        // 点击分页当前页数
        currentChange(val) {
            this.page = val;
            //当分页发生改变的时候存到本地更改本地存储好的参数
            if (!this.postList.params) {
                var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                if (newParamsList['budgetSource_params']) {
                    newParamsList['budgetSource_params'].page = val;
                    localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                } else {
                    var params = {
                        page: this.page,
                        row: this.row,
                        budget_item_rid: this.budget_item_rid,
                        budget_item_source_group_rid: this.budget_item_source_group_rid,
                        start_time: this.start_time,
                        end_time: this.end_time,
                        effectiveness: this.effectiveness
                    };
                    var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                    newParamsList['budgetSource_params'] = params;
                    localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                }
            }
            this.getList(0);
        },
        // 切换每页条数
        sizeChange(val) {
            this.row = val;
            //当页数发生改变的时候存到本地更改本地存储好的参数
            if (!this.postList.params) {
                var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                if (newParamsList['budgetSource_params']) {
                    newParamsList['budgetSource_params'].row = val;
                    localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                } else {
                    var params = {
                        page: this.page,
                        row: this.row,
                        budget_item_rid: this.budget_item_rid,
                        budget_item_source_group_rid: this.budget_item_source_group_rid,
                        start_time: this.start_time,
                        end_time: this.end_time,
                        effectiveness: this.effectiveness
                    };
                    var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                    newParamsList['budgetSource_params'] = params;
                    localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                }
            }
            this.getList(0);
        }
    }
};
</script>
<style lang="scss" scoped>
// 让“暂无数据”文本居中显示
/deep/ .el-table__empty-block {
    width: 100% !important;
    min-width: 100% !important;
    max-width: 100% !important;
    padding-right: 100% !important;
}
</style>